import BookOpen from "@redotech/redo-icons/book-open-01.svg";
import Calendar from "@redotech/redo-icons/calendar.svg";
import Podcast from "@redotech/redo-icons/podcast.svg";
import RedoSquareIcon from "@redotech/redo-icons/redo-square.svg";
import Search from "@redotech/redo-icons/search-sm.svg";
import Shapes from "@redotech/redo-icons/shapes.svg";
import ShopifyIcon from "@redotech/redo-icons/shopify_glyph_black.svg";
import Instagram from "@redotech/redo-icons/social-icon-instagram.svg";
import Linkedin from "@redotech/redo-icons/social-icon-linkedin.svg";
import Youtube from "@redotech/redo-icons/social-icon-youtube.svg";
import Users from "@redotech/redo-icons/users-01.svg";
import {
  FIRST_INSTALL_ATTRIBUTION_SOURCE_LABELS,
  type FirstInstallAttributionSource,
} from "@redotech/redo-model/onboarding";
import type { IntakeQuestion } from "../../registry/types";

type ReclaimAttributionOptionConfig = Pick<
  IntakeQuestion["options"][number],
  "Icon"
> & { value: FirstInstallAttributionSource };

const RECLAIM_ATTRIBUTION_OPTION_CONFIGS = [
  { value: "search", Icon: Search },
  { value: "shopify_app_store", Icon: ShopifyIcon },
  { value: "linkedin", Icon: Linkedin },
  { value: "youtube", Icon: Youtube },
  { value: "social", Icon: Instagram },
  { value: "podcast", Icon: Podcast },
  { value: "article", Icon: BookOpen },
  { value: "referral", Icon: Users },
  { value: "event", Icon: Calendar },
  { value: "existing_redo", Icon: RedoSquareIcon },
  { value: "other", Icon: Shapes },
] as const satisfies readonly ReclaimAttributionOptionConfig[];

export const RECLAIM_ATTRIBUTION_OPTIONS =
  RECLAIM_ATTRIBUTION_OPTION_CONFIGS.map((option) => ({
    ...option,
    label: FIRST_INSTALL_ATTRIBUTION_SOURCE_LABELS[option.value],
  })) satisfies (IntakeQuestion["options"][number] & {
    value: FirstInstallAttributionSource;
  })[];

export const RECLAIM_ATTRIBUTION_QUESTION = {
  id: "attribution_source",
  type: "single-select",
  prompt: "Where did you hear about us?",
  required: true,
  layout: "grid",
  options: RECLAIM_ATTRIBUTION_OPTIONS,
} satisfies IntakeQuestion;
